/*  global _ */
import {EventBus, mixins, components, RESERVATION_TYPE} from './config'
import config from '../../lib/config'
import {getNow, DateTime, parseDateTime, formatDate} from '../../lib/dates'
import {getQS, alert} from '../../lib/utils'

const {supercharged} = config

export default {
  name: 'page-book-cs-event-reservation',
  components,
  mixins,
  props: {
    settings: {},
    translations: {},
    reservationType: {
      default: RESERVATION_TYPE
    },
    reservationTitle: {
      default: 'Axe throwing'
    },
    reservationPageRoute: {
      default: 'supercharged.axe-throwing'
    },
    reservationCartItemType: {
      default: 'generic'
    },
  },
  data() {
    return {
      showBookGroupEventPrompt: false,
      participantsChangedAlert: '',
      freezeSlotRetrieval: false,
      editMode: false,
      editingId: null,
      chosenDate: '', //as wrapper for selectedDate
      numParticipants: null,
      selectedDuration: 0,
      contactPhone: supercharged.phone_with_extension || '774-847-9010,101',
      isAddingToCart: false,
    }
  },
  computed: {
    pageClasses() {
      return [
        `page-${this.reservationType}`
      ]
    },
    contactPhoneExt() {
      return this.contactPhone.replace(',', ' ext. ')
    },
  },
  watch: {
    showMiniCart(newValue) {
      if (this.preventTimerStartInEditMode) {
        return
      }
      if (newValue) {
        if (!this.timerIsRunning) {
          const holdStartsAt = this.holdStartsAt = getNow().toSeconds()
          this.holdEndsAt = (1 * holdStartsAt) + this.timeoutDuration
          this.startTimer(this.timeoutDuration)
        }
        if (!this.holdStartsAt || !this.holdEndsAt) {
          this.holdStartsAt = parseDateTime(this.timerStartTime).toSeconds()
          this.holdEndsAt = parseDateTime(this.timerEndTime).toSeconds()
        }
      } else {
        if (!this.needsToShowTimer) {
          this.stopTimer()
        }
      }
    },
    async selectedDate(newValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue && !this.freezeSlotRetrieval) {
        newValue = ('' + newValue).trim()
        await this.loadTimeslots(newValue, null, (...args) => this.createTimeslots(...args))
      }
      this.freezeSlotRetrieval = false
    },
    duration(value) {
      this.numTimeslots = Math.ceil(value / this.productDuration)
    },
    participants(value) {
      this.quantity = this.hasSelectedDurationProduct ? value: this.numTimeslots * value
    },
    numTimeslots(value) {
      this.quantity = this.hasSelectedDurationProduct ? this.participants: this.participants * value
    }
  },
  async created() {
    await this.hideGlobalTimer(true)
    this.mayResetCountdownTimer()
    await this.setReservationType(this.reservationType || RESERVATION_TYPE)
    this.setProductGroupTitle(this.reservationTitle || 'Axe throwing')
    this.setEditPageRoute(this.reservationPageRoute || 'supercharged.axe-throwing')
    this.setCartItemType(this.reservationCartItemType || 'axe-throwing')

    this.loadEditable()
    this.editMode = !!this.reservationEditItem
    EventBus.$on('cart-item-edit-reservations', async (item) => {
      await this.hydrateReservationFromCart(item)
      this.scrollToDate()
    })
    EventBus.$on('cart-item-deleted-reservations', () => {
      this.cleanTimeslots()
      this.scrollToDate()
    })
    EventBus.$on('cart-cleaned', cart => {
      this.cleanTimeslots()
      this.scrollToDate()
    })
    EventBus.$on('cart-go-back', cart  => {
      // vm.goBackToRaceShop()
    })
    EventBus.$on('cart-get-item-description', (item, cartItem, cart) => {
     // .selected-time-slots
    })
   EventBus.$on('timer.timeout', id => {
     const canAutoRemove = this.autoRemoveCartItemOnTimeout
     if (canAutoRemove) {
       this.cleanExistingItems()
     } else {
       this.cleanSelectedTimeslots()
     }
      let message = 'Time to hold your selection for reservation has expired.'
      if (this.editMode && canAutoRemove) {
        message += ' Your cart item has been removed.'
      }
      message += ' Please start over again!'
      this.scrollToDate()
      this.alert(message, {classes: 'text-danger'})
    })

    if (this.editMode) {
      const expired = this.hasExpired(this.reservationEditItem)
      if (expired) {
        EventBus.$emit('timer.timeout', this.currentLocationId)
        this.mayResetCountdownTimer()
      }
      if (!expired || !this.autoRemoveCartItemOnEditTimeout) {
        EventBus.$emit('cart-item-edit-reservations', this.reservationEditItem)
      }
    }
  },
  methods: {
    watchDuration(event) {
      const newValue = _.toFinite(this.selectedDuration)
      this.selectedDuration = newValue
      this.askAndRemoveSelectedTimeSlot(
        'change in the duration',
        () => {
          this.duration = newValue
          this.loadTimeslots()
        },
        () => {
          this.selectedDuration = this.duration
        },
      );
    },
    watchNumParticipants: _.debounce(function(event) {
      const newValue = Math.max(0, Math.round(this.numParticipants) || 0)
      if (this.minParticipants && newValue < this.minParticipants) {
        alert('Number of participants can not be less than ' + this.minParticipants)
        return
      }

      this.numParticipants = newValue
      this.askAndRemoveSelectedTimeSlot(
        'change in the number of participants',
        () => {
          this.participants = newValue
          this.$nextTick(() => {
            this.showPrompts()
          })
        },
        () => {
          this.numParticipants = this.participants
        }
      )
    }, 500),
    watchChosenDate(newValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue) {
        this.askAndRemoveSelectedTimeSlot(
          'change in date',
          () => {
            this.selectedDate = formatDate(newValue, 'yyyy-MM-dd')
          },
          () => {
            this.chosenDate = this.selectedDate
          },
        );
      }
    },

    hasExpired(item) {
      let expired = this.hasTimerExpired(item)
      if (!expired) {
        const earliestSlotTime = this.getEarliestSlotTime(item)
        if (earliestSlotTime) {
          expired = getNow(this.timezone, true) >= (earliestSlotTime - (this.availabilityBuffer * 60))
        }
      }
      return expired
    },
    hasTimerExpired(item) {
      const expiration = _.get(item, 'attributes.slot.hold.expire_at')
      if (expiration) {
        // expiration datetime set using UTC timezone in backend
        const ends = DateTime.fromSQL(expiration, {zone: 'UTC'})
        if (ends && ends.isValid) {
          return getNow('UTC') > ends
        }
      }
      return false
    },
    cleanSelectedTimeslots() {
      _.forOwn(this.selectedTimeslots, slot => {
        this.unholdSlot(slot)
      })
      this.cleanTimeslots()
    },
    cleanExistingItems() {
      this.cleanSelectedTimeslots()
      if (this.editMode) {
        this.removeExitingCartItems(this.editingId)
        this.editMode = false
      }
    },
    async removeExitingCartItems(id) {
      const mainItem = this.cartItem(id)
      if (mainItem) {
        await this.removeCartItem({id})
      }
      this.editingId = null
    },
    async addToCart(goto = true) {
      this.isAddingToCart = true
      const cartPage = 'page-cart'
      if (this.editingId) {
        await this.removeExitingCartItems(this.editingId)
      }
      await this.$nextTick()
      await this.addCartItems(this.proposedCart)
      this.setReservationEditItem(null)
      if (goto) {
        await this.$nextTick()
        this.goto(cartPage)
      } else {
        this.isAddingToCart = false
      }
    },
    showPrompts: _.debounce(function () {
      this.showBookGroupEventPrompt = this.moreThanMaxParticipants
    }, 500),
    async hydrateReservationFromCart(cartItem) {
      this.startHydratingData()
      const hasExpired = this.hasExpired(cartItem)
      this.freezeSlotRetrieval = true
      const {attributes}  = cartItem
      const {form: inputs} = attributes
      const selectedSlots = hasExpired ? {} : _.clone(inputs.selectedSlots)
      const otherInputs = _.clone(_.omit(inputs, ['selectedSlots']))
      await this.setInput(otherInputs)
      this.phoneConfirmation = _.get(otherInputs, 'contact.phone')
      this.emailConfirmation = _.get(otherInputs, 'contact.email')
      this.chosenDate = this.selectedDate
      this.numParticipants = this.participants
      this.selectedDuration = this.duration
      await this.loadTimeslots(inputs.selectedDate, selectedSlots, (...args) => this.createTimeslots(...args))
      // this.freezeSlotRetrieval = true

      await this.$nextTick()
        // this.setInput({selectedSlots})
      _.forOwn(selectedSlots, slot => {
        this.selectTimeslot(slot)
        const update = _.pick(slot, ['time', 'hold', 'selected'])
        this.updateSelectedAndRetrievedTimeslot(update)
      })
      // this.$forceUpdate()
      await this.$nextTick()
      if (hasExpired) {
        this.cleanSelectedTimeslots()
      }

      await this.$nextTick()
      this.setReservationEditItem(null)
      this.startHydratingData(false)
      this.preventTimerResetInEditMode = false
    },
    loadEditable() {
      const token = this.$route.query.token || _.get(getQS(), 'token')
      if (token) {
        const item = _.find(this.currentCartItems, ({id}) => id === token)
        this.setReservationEditItem(_.cloneDeep(item))
        this.editingId = token
        return item
      }
    },
    scrollToDate() {
      this.$nextTick(() => {
        this.scrollTo('.booking-date-input-box')
      })
    },
    async likeClick() {
      if (!this.cartNotReady) {
        await this.addToCart(false)
      }
    }
  }

}
